import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.split.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import weixin from '../weixin';
import config from './config';
import env from '../env';
var APP_APP_ID = 'wxca942bbff22e0e51'; // 腾讯视频appId

function verCompare(v1, v2) {
  if (v1 === v2) return 0;
  v1 = v1.split('.');
  v2 = v2.split('.');
  var len = v1.length >= v2.length ? v1.length : v2.length;
  var i = 0;
  var r = 0;

  while (len--) {
    var c1 = Number(v1[i] || 0);
    var c2 = Number(v2[i++] || 0);

    if (c2 > c1) {
      return 1;
    } else if (c2 < c1) {
      return -1;
    }
  }

  return r;
}

export var canGetInstallState = true;
export function ready() {
  return new Promise(function (resolve) {
    if (typeof WeixinJSBridge === 'undefined') {
      document.addEventListener('WeixinJSBridgeReady', resolve, false);
    } else {
      resolve();
    }
  });
}
export function getInstallState() {
  return _getInstallState.apply(this, arguments);
}

function _getInstallState() {
  _getInstallState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var conf,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            conf = _args.length > 0 && _args[0] !== undefined ? _args[0] : config;
            _context.next = 3;
            return ready();

          case 3:
            return _context.abrupt("return", new Promise(function (resolve) {
              WeixinJSBridge.invoke('getInstallState', {
                packageName: conf.packageName,
                packageUrl: conf.packageUrl
              }, function (n) {
                var o = n.err_msg || n.errMsg; // `errMsg`是用于兼容macOs微信模拟器报错,真实环境应该是`err_msg`

                if (o.indexOf('get_install_state:yes') > -1) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              });
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getInstallState.apply(this, arguments);
}

function weixinReady() {
  return _weixinReady.apply(this, arguments);
}

function _weixinReady() {
  _weixinReady = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve) {
              weixin.weixinReady(resolve);
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _weixinReady.apply(this, arguments);
}

export function launch(_x) {
  return _launch.apply(this, arguments);
}

function _launch() {
  _launch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(schemeUrl) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return weixinReady();

          case 2:
            return _context3.abrupt("return", new Promise(function (resolve) {
              var ua = navigator.userAgent;
              var versionStrArr = ua.match(/MicroMessenger\/([\d.]+)/);

              if (versionStrArr && versionStrArr.length === 2 && verCompare('6.5.6', versionStrArr[1]) >= 0) {
                if (ua.indexOf('iPad') !== -1 || !schemeUrl.match(/^(tenvideo2|txvideo):\/\//)) {
                  try {
                    WeixinJSBridge.invoke('launchApplication', {
                      schemeUrl: schemeUrl
                    }, function (res) {
                      resolve(res);
                    });
                  } catch (e) {
                    void 0;
                  }
                } else {
                  wx.invoke('launchApplication', {
                    appID: APP_APP_ID,
                    extInfo: schemeUrl,
                    parameter: schemeUrl
                  }, function (res) {
                    resolve(res);
                  });
                }
              } else {
                location.href = schemeUrl;
              }
            }));

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _launch.apply(this, arguments);
}

export function download() {
  return _download.apply(this, arguments);
}

function _download() {
  _download = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!env.isIos) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", new Promise(function (resolve) {
              WeixinJSBridge && WeixinJSBridge.invoke('launchApplication', {
                schemeUrl: config.download
              }, function (res) {
                resolve(res);
              });
            }));

          case 4:
            if (env.isAndroid) {
              window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.tencent.qqlive';
            }

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _download.apply(this, arguments);
}

export default {
  canGetInstallState: canGetInstallState,
  ready: ready,
  getInstallState: getInstallState,
  launch: launch,
  download: download
};